import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { connectAuthEmulator, firebaseAuth } from './services/firebase';
import { initSentry } from './services/sentry';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Sentry as early as possible
initSentry();

// Import Sentry test utilities in development mode
if (process.env.REACT_APP_ENV === 'development') {
  import('./utils/sentryTestUtils')
    .then(() => console.log('Sentry test utilities loaded. Use window.__sentryTestUtils in console to test Sentry integration'))
    .catch(error => console.error('Failed to load Sentry test utilities:', error));
}

if (process.env.REACT_APP_ENABLE_FIREBASE_EMULATOR_AUTH === 'true') {
  // Connect to the Auth Emulator only when running locally
  // The port (9099) should match what firebase emulators:start uses
  connectAuthEmulator(firebaseAuth, 'http://localhost:9099')
  console.log('Firebase Auth Emulator connected!')
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
